// EventsPanel/index.js
import { connect } from 'react-redux';
import DocumentLibraryPanel from '../../components/DocumentLibraryPanel';
import { documentType } from '../../constants';

import {
  onDocumentListBackArrowDispatch,
  onDocumentFolderShowDispatch,
  onResetDocumentDispatch,
  fetchAllDocumentsDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    documents: state.settings.allDocuments.items,
    allDocumentsForLibrary: state.settings.allDocuments.itemsCopy,
    currentDirectory: state.settings.currentDirectory,
    defaultDirectory: state.settings.defaultDirectory,
    isLoading: state.settings.allDocuments.isLoading,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onReset: () => {
      dispatch(onResetDocumentDispatch());
    },
    onBackClicked: () => {
      dispatch(onDocumentListBackArrowDispatch());
    },
    onShowFolderItems: (prefix) => {
      dispatch(onDocumentFolderShowDispatch(prefix));
    },
    fetchAllDocumentsForLibrary: (branchId) => {
      dispatch(fetchAllDocumentsDispatch(documentType.DOCUMENT_LIBRARY, branchId));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentLibraryPanel);
